/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import React from "react";
import { cn } from "@/lib/utils";

/*
 * The "everything is fine" mark: a soft ring with a rounded check drawn inside, in the current text colour.
 * One shape for the Home health block, its tiles and the router checks (styles: styles/command-center.css).
 * `draw` plays the short stroke-in once when it appears (the big one in the health block only).
 */
export const CheckBadge: React.FC<{ size?: number; draw?: boolean; className?: string }> = ({ size = 16, draw, className }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={cn("gh-check", draw && "gh-check--draw", className)}
    aria-hidden="true"
    focusable="false"
  >
    <circle className="gh-check-ring" cx="12" cy="12" r="10" />
    <path className="gh-check-mark" d="M7.5 12.6l3 3 6-6.6" pathLength={1} />
  </svg>
);
